export type ChildReport = {
  child_session_id: string;
  run_id?: string;
  started_at?: string | null;
};

/** Another run of the same child that opened before `than`; false when either start is unknown. */
export function isOlderRun(candidate: ChildReport, than: ChildReport) {
  return (
    candidate.run_id !== undefined &&
    candidate.run_id !== than.run_id &&
    Date.parse(candidate.started_at ?? "") < Date.parse(than.started_at ?? "")
  );
}
